import {Col, Row} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Back from "../layout/template/back";
import {useLocation} from "react-router-dom";
import CardOrder from "../cards/cardOrder";
import ApiService from "../../services/ApiService";

const AdminDetailOrder = () => {

    const location = useLocation();
    const [basketData, setBasketData] = useState();
    const [transactionId, setTransactionId] = useState();


    useEffect(() => {
        let basketId = location.state?.from

        ApiService.getBasketDetailById(basketId)
            .then(async basket => {
                let userData = await ApiService.getUserInfoFromEmailAdmin(basket.bookCourses[0].userMail)
                const transaction = basket.transactions.find(trans => {
                    return trans.status === "FULFILL";
                });
                basket["firstName"] = userData.firstName
                basket["lastName"] = userData.lastName
                basket["userMail"] = userData.email

                setBasketData(basket)
                setTransactionId(transaction)
            })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Row>
                <Col xs={12}>
                    <Row>
                        <Col>
                            <Back/>
                        </Col>
                    </Row>
                    <Row className={'justify-content-between'}>
                        <Col>
                            <div className={'title-page-section mt-5'}>
                                <h2 className={'title'}>Ordini</h2>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>

            {basketData !== undefined? <Row>
                <Col lg={6}>
                    <Row className={'mt-5 mb-2'}>
                        <Col>
                            <h2 className={'fw-bold'}>{basketData.createdAt}</h2>
                        </Col>
                    </Row>

                    <Row className={'mb-4'}>
                        <Col xs={12} lg={6}>
                            <div className={'paragraph-section mt-3 mb-2'}>
                                <p className={'fw-bold mb-0'}>Utente:</p>
                                <p>{basketData.firstName} {basketData.lastName}</p>
                            </div>
                        </Col>
                        <Col xs={12} lg={6}>
                            <div className={'paragraph-section mt-3 mb-2'}>
                                <p className={'fw-bold mb-0'}>Mail:</p>
                                <p>{basketData.userMail}</p>
                            </div>
                        </Col>
                        <Col xs={12}>
                            {basketData.bookCourses !== null ? <CardOrder basketData={basketData}/> : <></>}
                            {(transactionId && transactionId.id !== undefined)? "Transaction ID: " + transactionId.id : "" }
                        </Col>
                    </Row>
                </Col>
            </Row> : <></>}
        </>

    );
}

export default AdminDetailOrder;
